export const extractMyDealerId = (dealerId?: string): string | undefined => {
  if (!dealerId) {
    return undefined;
  }
  const matches = dealerId.match(/[A-Z]{3}(\d{5})[N,V]?/);
  if (!matches || matches.length < 2) {
    return undefined;
  }
  return matches[1];
};
